const stripHtml = (html: string) => {
    if (!html || typeof html !== 'string') {
        return '';
    }
    return html.replace(/<[^>]*>?/g, '');
}

export default stripHtml;const stripHtml = (html: string) => {
    if (!html || typeof html !== 'string') {
        return '';
    }
    return html.replace(/<[^>]*>?/g, '');
}

export default stripHtml;